var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children } from "react";
import { forwardRef, Input as ChakraInput, InputGroup as ChakraInputGroup, InputLeftAddon, InputLeftElement, InputRightAddon, InputRightElement, useTheme, } from "@chakra-ui/react";
import { useColorModeValue } from "@chakra-ui/system";
import { transparentize } from "../../core";
import { Size, Variant, ColorScheme } from "../../core/constants";
import { pick, getValidChildren } from "../../core/utils";
import FormControl from "../FormControl";
export const InputSize = pick(Size, ["sm", "md", "lg"]);
export const InputVariant = pick(Variant, [
    "outline",
    "filled",
    "flushed",
    "unstyled",
]);
// Wrap components in an InputGroup only if there are multiple components
const ConditionalInputGroup = ({ children, size }) => {
    const hasExtraElements = Children.count(getValidChildren(children)) > 1;
    if (hasExtraElements) {
        return React.createElement(ChakraInputGroup, { size: size }, children);
    }
    return React.createElement(React.Fragment, null, children);
};
/**
 * `Input` component is a component that is used to get user input in a text field.
 */
const Input = forwardRef((_a, ref) => {
    var { className, colorScheme, variantColor, label, name, error, helper, leftElement, rightElement, leftAddonText, rightAddonText, size, type } = _a, rest = __rest(_a, ["className", "colorScheme", "variantColor", "label", "name", "error", "helper", "leftElement", "rightElement", "leftAddonText", "rightAddonText", "size", "type"]);
    const scheme = colorScheme || variantColor;
    const theme = useTheme();
    const focusBorderColor = useColorModeValue(`${scheme}.500`, transparentize(`${scheme}.500`, 0.5)(theme));
    const errorBorderColor = useColorModeValue(`${ColorScheme.error}.500`, transparentize(`${ColorScheme.error}.500`, 1)(theme));
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(ConditionalInputGroup, { size: size },
            leftElement && React.createElement(InputLeftElement, null, leftElement),
            leftAddonText && React.createElement(InputLeftAddon, null, leftAddonText),
            React.createElement(ChakraInput, Object.assign({}, rest, { ref: ref, name: name, size: size, type: type, colorScheme: scheme, focusBorderColor: focusBorderColor, errorBorderColor: errorBorderColor, className: className })),
            rightElement && (React.createElement(InputRightElement, null, rightElement)),
            rightAddonText && (React.createElement(InputRightAddon, null, rightAddonText)))));
});
Input.displayName = "Input";
export default Input;
//# sourceMappingURL=Input.js.map